import { useEffect, useState } from "react";
import { getCampaigns } from "@/lib/api";
import { Sparkles } from "lucide-react";

export function AnnouncementBar() {
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    getCampaigns()
      .then((c) => setCampaign(c.find((x) => x.show_in_bar && x.active !== false) || c.find((x) => x.active !== false) || c[0]))
      .catch(() => {});
  }, []);

  return (
    <div data-testid="announcement-bar" className="bg-shule-goldlight/60 text-shule-coffee">
      <div className="container-shule flex items-center justify-center gap-2 py-2 text-[11px] sm:text-xs tracking-wide font-medium">
        <Sparkles className="w-3.5 h-3.5 text-shule-gold" aria-hidden="true" />
        <span>750 TL üzeri siparişlerde ücretsiz kargo</span>
        <span className="hidden sm:inline text-shule-soft">·</span>
        <span className="hidden sm:inline">{campaign ? campaign.title : "Shule Club üyelerine özel ayrıcalıklar"}</span>
      </div>
    </div>
  );
}
